{
    "consentModal": {
        "title": "Kekszeit!",
        "description": "<div>Wir und unsere Partner setzen Cookies ein und verarbeiten Daten. Einige Cookies und Datenverarbeitungen sind technisch notwendig, andere helfen uns, Funktionen auf unserer Website zur Verfügung zu stellen.</div><br /><div><em>Alle ablehnen</em> unterbindet diese Verbindungen, aber einige Funktionen der Website (wie das Kontaktformular) könnten nicht verfügbar sein.</div><br /><div>Mit <em>Alle annehmen</em> stimmst Du der Verarbeitung der auf Deinem Gerät gespeicherten Daten wie z.B. Identifikatoren oder IP-Adressen für diese Verarbeitungszwecke gem. § 25 Abs. 1 TDDDG sowie Art. 6 Abs. 1 lit. a DSGVO zu. Darüber hinaus willigst Du gem. Art. 49 Abs. 1 DSGVO ein, dass auch Anbieter in den USA Deine Daten verarbeiten. In diesem Fall ist es möglich, dass die übermittelten Daten durch örtliche Behörden verarbeitet werden.</div><br /><div>Unter <em>Einstellungen</em> kannst Du einzelne Verbindungen erlauben und findest detailliertere Informationen.</div>",
        "acceptAllBtn": "Alle annehmen",
        "acceptNecessaryBtn": "Alle ablehnen",
        "showPreferencesBtn": "Einstellungen verwalten",
        "footer": "<a href=\"pages/datenschutz.html\">Datenschutzerklärung</a>"
    },
    "preferencesModal": {
        "title": "Datenschutzeinstellungen",
        "acceptAllBtn": "Alle annehmen",
        "acceptNecessaryBtn": "Alle ablehnen",
        "savePreferencesBtn": "Einstellungen speichern",
        "closeIconLabel": "Schließen",
        "sections": [
            {
                "title": "Nutzung von Cookies und Daten",
                "description": "Wir setzen Cookies ein und verarbeiten Daten, um grundlegende Funktionen auf unserer Website bereitzustellen und unser Angebot zu verbessern."
            },
            {
                "title": "Notwendige Cookies",
                "description": "Diese Cookies sind notwendig für das Funktionieren der Website und deren Betrieb, wie zum Beispiel das Speichern Deiner Auswahl hier.",
                "linkedCategory": "necessary",
                "cookieTable": {
                    "headers": {
                        "name": "Name",
                        "domain": "Dienst",
                        "description": "Beschreibung",
                        "expiration": "Ablauf"
                    },
                    "body": [
                        {
                            "name": "cc_cookie",
                            "domain": "skinfactory.tattoo",
                            "description": "Deine Auswahl bei diesen Datenschutzeinstellungen hier.",
                            "expiration": "6 Monate"
                        }
                    ]
                }
            },
            {
                "title": "Funktionalitäts-Cookies",
                "description": "Diese Cookies erlauben uns, nützliche Funktionen auf der Website zur Verfügung zu stellen und Inhalte anderer Websites einzubinden.",
                "linkedCategory": "functionality",
                "cookieTable": {
                    "headers": {
                        "name": "Name",
                        "domain": "Dienst",
                        "description": "Beschreibung",
                        "expiration": "Ablauf"
                    },
                    "body": [
                        {
                            "name": "elfsight_viewed_recently",
                            "domain": "elfsight.com",
                            "description": "Wir nutzen Elfsight für unser Kontaktformular, unseren Instagram Feed und die Einblendung von Google Reviews. Dieses Cookie soll schnelles wiederholtes Abschicken des Kontaktformulars verhindern.",
                            "expiration": "Verfällt alle 15 Sekunden"
                        },
                    ]
                }
            },
            {
                "title": "Weitere Informationen",
                "description": "Bitte kontaktiere uns bei weiteren Fragen zu unserer Datenverarbeitung oder unserer Verwendung von Cookies."
            }
        ]
    }
}
